import { render, staticRenderFns } from "./FaqAccordionItem.vue?vue&type=template&id=a4f50618"
import script from "./FaqAccordionItem.vue?vue&type=script&lang=js"
export * from "./FaqAccordionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports